export default __webpack_public_path__ + "static/media/fr_dark.a4a85601.png";